export const menuItems_OBJ = [
  {
    title: "HOME",
    url: "/home",
  },
  {
    title: "PHOTOS",
    url: "/photos",
  },
  {
    title: "BIO",
    url: "/bio",
  },
  {
    title: "CONTACTS",
    url: "/contacts",
  },
];
